import { t } from 'i18next';
import { BreadcrumbsElement } from 'shared/components/breadcrumbs/breadcrumbs';
import { APP_URL } from 'shared/constants/common';

export const setStaticBreadcrumbs = (breadcrumbsLastElem: BreadcrumbsElement, newBreadcrumbs: Array<BreadcrumbsElement>, pathLocation: string) => {
	switch (pathLocation) {
		case APP_URL.sport:
			breadcrumbsLastElem.label = t('offer');
			newBreadcrumbs.push(breadcrumbsLastElem);
			break;
		case APP_URL.live:
			breadcrumbsLastElem.label = t('live');
			newBreadcrumbs.push(breadcrumbsLastElem);
			break;
		case APP_URL.eSport:
			breadcrumbsLastElem.label = t('eSport');
			newBreadcrumbs.push(breadcrumbsLastElem);
			break;
		case APP_URL.virtualSports:
			breadcrumbsLastElem.label = t('virtualSports');
			newBreadcrumbs.push(breadcrumbsLastElem);
			break;
		case APP_URL.cardGames:
			breadcrumbsLastElem.label = t('cardGames');
			newBreadcrumbs.push(breadcrumbsLastElem);
			break;
		case APP_URL.entertainment:
			breadcrumbsLastElem.label = t('entertainment');
			newBreadcrumbs.push(breadcrumbsLastElem);
			break;
		case APP_URL.promotion:
			breadcrumbsLastElem.label = t('promotion');
			newBreadcrumbs.push(breadcrumbsLastElem);
			break;
		case APP_URL.privacy:
			breadcrumbsLastElem.label = t('privacyPolicy');
			newBreadcrumbs.push(breadcrumbsLastElem);
			break;
		case APP_URL.regulations:
			breadcrumbsLastElem.label = t('regulations');
			newBreadcrumbs.push(breadcrumbsLastElem);
			break;
		case APP_URL.contact:
			breadcrumbsLastElem.label = t('contact');
			newBreadcrumbs.push(breadcrumbsLastElem);
			break;
		case APP_URL.usefulLinks:
			breadcrumbsLastElem.label = t('useFullLink');
			newBreadcrumbs.push(breadcrumbsLastElem);
			break;
		case APP_URL.betMarking:
			breadcrumbsLastElem.label = t('Oznaczeniadozakładów');
			newBreadcrumbs.push(breadcrumbsLastElem);
			break;
		case APP_URL.aplikacjaMobilna:
			breadcrumbsLastElem.label = t('mobileApplication');
			newBreadcrumbs.push(breadcrumbsLastElem);
			break;
		case APP_URL.kodPromocyjnyBetfan:
			breadcrumbsLastElem.label = t('promoCodes');
			newBreadcrumbs.push(breadcrumbsLastElem);
			break;
		case APP_URL.payment:
			breadcrumbsLastElem.label = t('paymentFooter');
			newBreadcrumbs.push(breadcrumbsLastElem);
			break;
		case APP_URL.todaysOffer:
			breadcrumbsLastElem.label = t('todayOffer');
			newBreadcrumbs.push(breadcrumbsLastElem);
			break;
		case APP_URL.oNas:
			breadcrumbsLastElem.label = t('aboutUs');
			newBreadcrumbs.push(breadcrumbsLastElem);
			break;
		case APP_URL.slownik:
			breadcrumbsLastElem.label = t('slownik');
			newBreadcrumbs.push(breadcrumbsLastElem);
			break;
		case APP_URL.rangiVip:
			breadcrumbsLastElem.label = t('rangiVip');
			newBreadcrumbs.push(breadcrumbsLastElem);
			break;
		case APP_URL.betMatch:
			breadcrumbsLastElem.label = t('betMatch');
			newBreadcrumbs.push(breadcrumbsLastElem);
			break;
		case APP_URL.dailyChallenge:
			breadcrumbsLastElem.label = t('dailyChallenge');
			newBreadcrumbs.push(breadcrumbsLastElem);
			break;
		case APP_URL.chatVip:
			breadcrumbsLastElem.label = t('chatVip');
			newBreadcrumbs.push(breadcrumbsLastElem);
			break;
		case APP_URL.certificateOfWinningInfo:
			breadcrumbsLastElem.label = t('certificateOfWinning');
			newBreadcrumbs.push(breadcrumbsLastElem);
			break;
	}
};
